/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import axios from 'axios';
import InputMask from 'react-input-mask';

import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

import { STORE_FIELDS } from '../FormStore';
import { GeneralContext } from '../../../../core/app-context/GeneralContext';

export const axiosViaCEP = axios.create({
  baseURL: 'https://viacep.com.br/ws',
  headers: {
    'Content-Type': 'application/json',
  },
});

const getAddressByCep = async (cep) => {
  const response = await axiosViaCEP.get(`/${cep}/json/`);
  return response.data;
};

export default function FormAddress({
  onChange,
  formState,
  formError,
  setFormState,
}) {
  const { setErrorMessage } = useContext(GeneralContext);

  const { STREET, CITY, STATE, ZIP_CODE, COMPLEMENT, NUMBER, ADDR_DISTRICT } =
    STORE_FIELDS;

  const handleGetAddress = async () => {
    if (formState[ZIP_CODE].length > 7) {
      const responseAddress = await getAddressByCep(formState[ZIP_CODE]);
      if (responseAddress.erro !== true) {
        setFormState({
          ...formState,
          [STREET]: responseAddress.logradouro,
          [CITY]: responseAddress.localidade,
          [STATE]: responseAddress.uf,
          [ADDR_DISTRICT]: responseAddress.bairro,
          [COMPLEMENT]: responseAddress.complemento,
        });
      } else {
        setErrorMessage('CEP não encontrado');
        setFormState({
          ...formState,
          [STREET]: '',
          [CITY]: '',
          [STATE]: '',
          [ADDR_DISTRICT]: '',
          [COMPLEMENT]: '',
          [NUMBER]: '',
        });
      }
    }
  };

  return (
    <>
      <InputMask
        mask="99999-999"
        maskPlaceholder={null}
        value={formState[ZIP_CODE]}
        onBlur={handleGetAddress}
        onChange={(e) => {
          const cleannedValue = e.target.value
            .replace(/-/g, '')
            .replace(/_/g, '');
          onChange(ZIP_CODE, cleannedValue);
        }}
      >
        {(inputProps) => (
          <TextField
            {...inputProps}
            id="outlined-basic"
            label="CEP *"
            variant="outlined"
            error={!!formError[ZIP_CODE]}
            helperText={formError[ZIP_CODE]}
          />
        )}
      </InputMask>
      <TextField
        id="outlined-basic"
        label="Rua *"
        variant="outlined"
        value={formState[STREET]}
        onChange={(e) => onChange(STREET, e.target.value)}
        error={!!formError[STREET]}
        helperText={formError[STREET]}
      />
      <TextField
        id="outlined-basic"
        label="Bairro *"
        variant="outlined"
        value={formState[ADDR_DISTRICT]}
        onChange={(e) => onChange(ADDR_DISTRICT, e.target.value)}
        error={!!formError[ADDR_DISTRICT]}
        helperText={formError[ADDR_DISTRICT]}
      />
      <div
        style={{
          display: 'flex',
          alingItens: 'center',
          justifyContent: 'space-between',
        }}
      >
        <TextField
          id="outlined-basic"
          label="Numero *"
          variant="outlined"
          value={formState[NUMBER]}
          onChange={(e) => onChange(NUMBER, e.target.value)}
          error={!!formError[NUMBER]}
          helperText={formError[NUMBER]}
        />
        <TextField
          id="outlined-basic"
          label="Cidade *"
          variant="outlined"
          value={formState[CITY]}
          onChange={(e) => onChange(CITY, e.target.value)}
          error={!!formError[CITY]}
          helperText={formError[CITY]}
        />
        <InputMask
          mask="**"
          maskPlaceholder={null}
          value={formState[STATE]}
          onChange={(e) => onChange(STATE, e.target.value)}
        >
          {(inputProps) => (
            <TextField
              {...inputProps}
              id="outlined-basic"
              label="Estado *"
              variant="outlined"
              error={!!formError[STATE]}
              helperText={formError[STATE]}
            />
          )}
        </InputMask>
      </div>
      <TextField
        id="outlined-basic"
        label="Complemento "
        variant="outlined"
        value={formState[COMPLEMENT]}
        onChange={(e) => onChange(COMPLEMENT, e.target.value)}
        error={!!formError[COMPLEMENT]}
        helperText={formError[COMPLEMENT]}
      />
    </>
  );
}

FormAddress.propTypes = {
  onChange: PropTypes.func.isRequired,
  formState: PropTypes.objectOf(PropTypes.string).isRequired,
  formError: PropTypes.objectOf(PropTypes.string).isRequired,
  setFormState: PropTypes.objectOf(PropTypes.string).isRequired,
};
